import {
  NOT_FOUND,
  UNEXPECTED_ERROR,
  VALIDATION_ERROR,
} from '@monetize/constants';
import { ZodError } from 'zod';

export class UserFacingError extends Error {
  error: string;
  additionalData?: unknown;
  override message: string;
  constructor(
    message: string | Error | UserFacingError,
    type?: string,
    additionalData?: unknown,
  ) {
    if (message instanceof ZodError) {
      const errorDetails = Object.values(
        message.flatten((issue) => ({
          message: `Invalid request: '${issue.path.join('.')}' is ${
            issue.message
          }`,
          errorCode: issue.code,
        })).fieldErrors,
      );

      const formattedMessage = errorDetails
        .flatMap((item) => item)
        .map((item) => (item as { message: string })?.message)
        .filter(Boolean)
        .join(', ');

      type = VALIDATION_ERROR;
      super(formattedMessage);
      this.name = 'ValidationError';
      this.message = formattedMessage;
      this.additionalData = message.issues;
      this.stack = message.stack;
    } else if (message instanceof Error) {
      super(message.message);
      this.name = message.name;
      this.stack = message.stack || '';
      this.message = message.message || 'An unknown error occurred';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type = type || (message as any).error;
      this.additionalData = (message as any).additionalData;
    } else {
      super(message);
      this.message = message;
    }
    this.error = type || UNEXPECTED_ERROR;
    this.additionalData = this.additionalData || additionalData;
  }
}

export class NotFoundError extends Error {
  error: string;
  additionalData?: unknown;
  constructor(message: string | Error, additionalData?: unknown) {
    if (message instanceof Error) {
      super(message.message);
      this.name = message.name;
      this.stack = message.stack || '';
    } else {
      super(message);
    }
    this.error = NOT_FOUND;
    this.additionalData = additionalData;
  }
}
